import localforage from "localforage";
import { post } from "../shared/http";
import { handleException } from "../util/util";
export const findIndexDB = async (dbName) => {
    let idbDatabases, idbDatabase;
    if (typeof indexedDB.databases === 'function') {
        await indexedDB.databases().then(function (databases) {
            idbDatabases = databases;
        });
        idbDatabase = idbDatabases.find((idbDB) => { return (idbDB.name === dbName); });
        if (!idbDatabase) { return false; }
        return idbDatabase;
    } else {
        try {
            return new Promise((resolve) => {
                const openDbRequest = indexedDB.open(dbName);
                openDbRequest.onsuccess = async () => {
                    const indexDb = openDbRequest.result;
                    const indexDbStoreNames = indexDb.objectStoreNames;
                    indexDb.close();
                    if (indexDbStoreNames && indexDbStoreNames.length === 0) { resolve(false); }
                    else { resolve(indexDbStoreNames); }
                };
            });
        } catch (error) {
            return false;
        }
    }
}
export const createIndexDBandInstance = async (dbStoreName, other = {}) => {
    const indexDBInstance = localforage.createInstance({
        name: other.userId ? `${other.bookISBN}-${other.userId}_CC` : other.indexDbName,
        driver: localforage.INDEXEDDB,
        storeName: dbStoreName
    });
    return indexDBInstance;
}
export const findLocalForageInstance = async (dbName, dbStoreName) => {
    try {
        return new Promise((resolve) => {
            const openDbRequest = indexedDB.open(dbName);
            openDbRequest.onsuccess = async () => {
                const indexDb = openDbRequest.result;
                const indexDbStoreNames = indexDb.objectStoreNames;
                indexDb.close();
                if (indexDbStoreNames.contains(dbStoreName)) {
                    let indexDbName = dbName;
                    const dbStoreInstance = await createIndexDBandInstance(dbStoreName, { indexDbName });
                    resolve(dbStoreInstance);
                } else { resolve(false); }
            };
        });
    } catch (error) {
        return false;
    }
}
export const addUserBookDetails = async (offlineBookData, other = {}) => {
    if (!Object.keys(other).length) { return false; }
    let ccLinks = await createIndexDBandInstance('cc-links', other);
    ccLinks.setItem(`CC_ISBN|${other.bookISBN}`, offlineBookData);
}
export const addUserAllBooksDetails = async (bookData, other = {}) => {
    if (!Object.keys(other).length) { return false; }
    let indexDbName = `${other.userId}_CC_Books`;
    let ccBooks = await createIndexDBandInstance('cc-books', { indexDbName })
    ccBooks.setItem(`CC_BookISBN|${other.bookISBN}`, bookData);
}
export const addChaptersList = async (chaptersMetaDataList, other = {}, setLinkGenerateLoadPerc) => {
    if (!chaptersMetaDataList) { return false }
    if (!Object.keys(other).length) { return false; }
    let chapterSuplementList = await createIndexDBandInstance('chapter-suplement-list', other), chapterIdKey;
    let ccContent = await createIndexDBandInstance('cc-content', other);
    let percentToIncress = 90 / chaptersMetaDataList.length;
    let currentProgress = 0;
    for (let i = 0; i < chaptersMetaDataList.length; i++) {
        let chapterEle = chaptersMetaDataList[i];
        chapterIdKey = chapterEle && chapterEle.chapterId;
        if (chapterIdKey) {
            await chapterSuplementList.setItem(`chapterId|${chapterIdKey}`, chapterEle);
            chapterEle.pageHtmlLocation && await addChapterContentAndImages(ccContent, chapterIdKey, chapterEle.pageHtmlLocation, other);
            if (chapterEle.subChapters) {
                for (let j = 0; j < (chapterEle.subChapters).length; j++) {
                    let subChpaterEle = chapterEle.subChapters[j];
                    await addChapterContentAndImages(ccContent, chapterIdKey, subChpaterEle.pageHtmlLocation, other);
                }
            }
        }
        currentProgress += percentToIncress;
        setLinkGenerateLoadPerc(`${currentProgress}%`)
    };
    return true;
}
export const addChapterContentAndImages = async (ccContentDb, chapterID, htmlUrl, other) => {
    await addChapterContent(ccContentDb, htmlUrl);
    let htmlCont, htmlContText;
    try {
        htmlCont = await ccContentDb.getItem(htmlUrl.split('?')[0]);
        if (!htmlCont) { return false; }
        htmlContText = await (htmlCont).text();
    } catch (error) {
        return false;
    }
    let contImgCDNUrls = await extractChapterImages(htmlContText, other);
    if (!contImgCDNUrls) { return false; }
    addChapterImages(ccContentDb, contImgCDNUrls, chapterID);
};
export const addChapterContent = async (ccContentIdb, url) => {
    let chaptContKey = url.split('?')[0];
    try {
        let response = await fetch(url);
        let responseValue = await response.blob();
        if (!response.ok) {
            throw Error(response.statusText);
        }
        await ccContentIdb.setItem(chaptContKey, responseValue);
    } catch (error) {
        return false;
    }
}
export const extractChapterImages = async (htmlContent, other) => {
    const parser = new DOMParser();
    let doc = parser.parseFromString(htmlContent, 'text/html');
    let imgs = doc.querySelectorAll('img'), imgSrc;
    let imgsCDNUrls = [], imgsCDNSrcs = [];
    for (let i = 0; i < imgs.length; i++) {
        imgSrc = imgs[i].getAttribute('src');
        let imgUrl = `/casebook/${other.bookISBN}/ex-epub/OPS/${imgSrc}`
        let reqData = { "genericServiceRequestVO": { "inputBaseUrl": imgUrl } };
        imgsCDNUrls.push(fetchImgCDNUrl(reqData));
    };
    const responses = await Promise.all(imgsCDNUrls);
    for (let i = 0; i < imgs.length; i++) {
        imgSrc = imgs[i].getAttribute('src');
        let imgCDNUrl = responses[i].genericServiceResponseVO.cdnUrl;
        imgsCDNSrcs.push({ 'imageSrc': imgSrc, 'imageCdnUrl': imgCDNUrl });
    };
    return imgsCDNSrcs;
}
const fetchImgCDNUrl = async (reqData) => {
    let fetchResponse = await post("/manageUrlService/getCDNUrl", reqData, "ENV");
    if (fetchResponse.status === 200) { return fetchResponse.json(); }
}
export const addChapterImages = async (ccContentIdb, imagesData, chapterID) => {
    let fetchURLRequest = [];
    imagesData.map(async function (element) {
        const imdCdnRes = fetchImgCDNRes(element.imageCdnUrl)
        imdCdnRes && fetchURLRequest.push(imdCdnRes);
    });
    const responses = await Promise.all(fetchURLRequest);
    imagesData.map(async (element, i) => {
        await ccContentIdb.setItem(`${chapterID}|${element.imageSrc}`, responses[i]);
    })
}
const fetchImgCDNRes = async (url) => {
    return await fetch(url).then(imgRes => { return imgRes.blob(); }).catch(() => { return false; });
}
export const addChapterHighlights = async (chapterHighlights, other = {}) => {
    if (!chapterHighlights) { return false };
    if (!Object.keys(other).length) { return false; }
    let ccHighlight = await createIndexDBandInstance('cc-highlight', other);
    try {
        Object.keys(chapterHighlights).forEach((chapterId) => {
            ccHighlight.setItem(`chapterId|${chapterId}`, chapterHighlights[chapterId]);
        });
    } catch (error) {
        return false;
    }
}
export const addChapterProfLinks = async (chapterLinks, other = {}) => {
    if (!chapterLinks) { return false };
    if (!Object.keys(other).length) { return false; }
    let ccProfessorLink = await createIndexDBandInstance('cc-professor-link', other);
    try {
        Object.keys(chapterLinks).forEach((chapterId) => {
            ccProfessorLink.setItem(`chapterId|${chapterId}`, chapterLinks[chapterId]);
        });
    } catch (error) {
        return false;
    }
}
export const addUserSettings = async (userVO, other = {}) => {
    if (!userVO) { return false };
    if (!Object.keys(other).length) { return false; }
    let ccSettings = await createIndexDBandInstance('cc-settings', other);
    ccSettings.setItem(`userVO`, userVO);
}
export const getBrowserStorageStatus = async () => {
    try {
        const { quota, usage } = await navigator.storage.estimate();
        const reminingStorage = (quota - usage) / 1000000;
        return reminingStorage;
    } catch (error) {
        return -1;
    }
}
export const getUserBookDetails = async (idbKey, other = {}) => {
    if (!idbKey) { return false }
    if (!Object.keys(other).length) { return false; }
    const indbName = `${other.bookISBN}-${other.userId}_CC`;
    const isDbPresent = await findIndexDB((indbName));
    if (!isDbPresent) { return false; }
    const isCcLinksInstance = await findLocalForageInstance(indbName, 'cc-links');
    if (!isCcLinksInstance) { return false; }
    let downloadedBook;
    try {
        downloadedBook = await isCcLinksInstance.getItem(idbKey);
        if (!downloadedBook) { return false; }
        return downloadedBook;
    } catch (error) {
        return false;
    }
}
export const getUserAllBooksDetails = async (other = {}) => {
    let idbStoredBooks = [];
    const indbName = `${other.userId}_CC_Books`;
    const isDbPresent = await findIndexDB((indbName));
    if (!isDbPresent) { return false; }
    const isCcBooksInstance = await findLocalForageInstance(indbName, 'cc-books');
    if (!isCcBooksInstance) { return false; }
    await isCcBooksInstance.iterate((value) => { idbStoredBooks.push(value) });
    return idbStoredBooks;
}
export const getChaptersList = async (other = {}) => {
    const indbName = `${other.bookISBN}-${other.userId}_CC`;
    const isDbPresent = await findIndexDB((indbName));
    if (!isDbPresent) { return false; }
    const isChapterSuplementListInstance = await findLocalForageInstance(indbName, 'chapter-suplement-list');
    if (!isChapterSuplementListInstance) { return false; }
    let extractChaptersList = [];
    await isChapterSuplementListInstance.iterate((value) => { extractChaptersList.push(value); });
    return extractChaptersList;
}
export const getChapterContentAndImages = async (idbKeyUrl, other = {}) => {
    if (!idbKeyUrl) { return false }
    if (!Object.keys(other).length) { return false; }
    const indbName = `${other.bookISBN}-${other.userId}_CC`;
    const isDbPresent = await findIndexDB((indbName));
    if (!isDbPresent) { return false; }
    const isCcContentInstance = await findLocalForageInstance(indbName, 'cc-content');
    if (!isCcContentInstance) { return false; }
    let downChpatCont;
    try {
        downChpatCont = await isCcContentInstance.getItem(idbKeyUrl);
        if (!downChpatCont) { return false; }
        return downChpatCont;
    } catch (error) {
        return false;
    }
}
export const getChapterHighlights = async (idbKey, other = {}) => {
    if (!idbKey) { return false }
    if (!Object.keys(other).length) { return false; }
    const indbName = `${other.bookISBN}-${other.userId}_CC`;
    const isDbPresent = await findIndexDB((indbName));
    if (!isDbPresent) { return false; }
    const isCcHighlightInstance = await findLocalForageInstance(indbName, 'cc-highlight');
    if (!isCcHighlightInstance) { return false; }
    let chaptHighlights;
    try {
        chaptHighlights = await isCcHighlightInstance.getItem(`chapterId|${idbKey}`);
        if (!chaptHighlights) { return false; }
        return chaptHighlights;
    } catch (error) {
        return false;
    }
}
export const getChapterProfLinks = async (idbKey, other = {}) => {
    if (!idbKey) { return false }
    if (!Object.keys(other).length) { return false; }
    const indbName = `${other.bookISBN}-${other.userId}_CC`;
    const isDbPresent = await findIndexDB((indbName));
    if (!isDbPresent) { return false; }
    const isCcProfessorLink = await findLocalForageInstance(indbName, 'cc-professor-link');
    if (!isCcProfessorLink) { return false; }
    let professorLink;
    try {
        professorLink = await isCcProfessorLink.getItem(`chapterId|${idbKey}`);
        if (!professorLink) { return false; }
        return professorLink;
    } catch (error) {
        return false;
    }
}
export const getUserSettings = async (keyName, other = {}) => {
    if (!keyName) { return false }
    if (!Object.keys(other).length) { return false; }
    const indbName = `${other.isbn}-${other.userId}_CC`;
    const isDbPresent = await findIndexDB((indbName));
    if (!isDbPresent) { return false; }
    const isCcSettingInstance = await findLocalForageInstance(indbName, 'cc-settings');
    if (!isCcSettingInstance) { return false; }
    return await isCcSettingInstance.getItem(keyName);
}
export const removeIdbUserBook = async (fromPage, other = {}) => {
    if (!Object.keys(other).length) { return false; }
    if (!fromPage) { return false; }
    switch (fromPage) {
        case 'offlineLinks':
            const fetchBookList = await fetchOfflineLinks();
            if (!fetchBookList || !fetchBookList.length > 0) { return false; }
            return fetchBookList;
        case 'offlineApp':
            const fetchedBookList = await fetchOfflineLinks();
            if (!fetchedBookList) { return false; }
            const idbBooksDetails = await getUserAllBooksDetails(other);
            if (!idbBooksDetails || !idbBooksDetails.length > 0) { return false; }
            if (!fetchedBookList.length > 0) {
                idbBooksDetails.map(downlBook => {
                    const idbDetails = { bookISBN: downlBook.bookISBN, userId: other.userId }
                    removeUserBookDetails("", idbDetails);
                    return downlBook;
                });
                return false;
            }
            idbBooksDetails.map(downlBook => {
                const isBookDownloadedBrowserMatched = fetchedBookList.filter(fetchedBook => (
                    downlBook.bookISBN === fetchedBook.bookISBN &&
                    downlBook.browser === fetchedBook.browser &&
                    downlBook.uuid === fetchedBook.uuid
                ));
                if (isBookDownloadedBrowserMatched && isBookDownloadedBrowserMatched.length === 0) {
                    const idbDetails = { bookISBN: downlBook.bookISBN, userId: other.userId }
                    removeUserBookDetails("", idbDetails);
                }
                return downlBook;
            });
            return true;
        default:
            break;
    }
}
export const fetchOfflineLinks = async () => {
    let fetchedBookVo = false;
    await post("/OfflineService/getOfflineUrlDetailsForUsers", {}, "ENV")
        .then(response => response.json())
        .then(data => {
            if (data.status === "false" && data.wkErrorCode) {
                handleException(data);
                return false;
            }
            data.bookVOList = data.bookVOList && (Array.isArray(data.bookVOList) ? data.bookVOList : [data.bookVOList]);
            fetchedBookVo = data.bookVOList ? data.bookVOList : [];
        }).catch(error => {
            console.error("There has been a problem with your fetch operation:", error);
            return false;
        });
    return fetchedBookVo;
}
export const removeUserBookDetails = async (removeBookUuid = "", other = {}) => {
    if (!Object.keys(other).length) { return false; }
    const idbName = `${other.bookISBN}-${other.userId}_CC`;
    const isDbPresent = await findIndexDB((idbName));
    const idbObjName = `CC_ISBN|${other.bookISBN}`;
    if (!isDbPresent) { return false; }
    const userBookInfo = await getUserBookDetails(idbObjName, other);
    if (!userBookInfo) { return false; }
    if (removeBookUuid && removeBookUuid !== userBookInfo.uuid) { return false; }
    indexedDB.deleteDatabase(idbName);
    await removeUserAllBooksDetails(other);
    return true;
}
export const removeUserAllBooksDetails = async (other = {}) => {
    const idbName = `${other.userId}_CC_Books`;
    const idbObjName = `CC_BookISBN|${other.bookISBN}`;
    const isDbPresent = await findIndexDB((idbName));
    if (!isDbPresent) { return false; }
    const isCcBooksInstance = await findLocalForageInstance(idbName, 'cc-books');
    if (!isCcBooksInstance) { return false; }
    isCcBooksInstance.removeItem(idbObjName);
    const allUserBooks = await getUserAllBooksDetails(other);
    if (allUserBooks.length === 0) { indexedDB.deleteDatabase(idbName); }
}
export const removeChaptersList = async (removeChapersIdList, other = {}) => {
    if (!removeChapersIdList) { return false }
    if (!Object.keys(other).length) { return false; }
    const indbName = `${other.bookISBN}-${other.userId}_CC`;
    const isDbPresent = await findIndexDB((indbName));
    if (!isDbPresent) { return false; }
    const isChapterSuplementListInstance = await findLocalForageInstance(indbName, 'chapter-suplement-list');
    const isCcHighlightInstance = await findLocalForageInstance(indbName, 'cc-highlight');
    const isCcContentInstance = await findLocalForageInstance(indbName, 'cc-content');
    let chaptCommonIdbKey, ccContIdbKey;
    try {
        if (!isChapterSuplementListInstance) { return false; }
        await removeChapersIdList.forEach((chaptId) => {
            chaptCommonIdbKey = `chapterId|${chaptId}`; ccContIdbKey = chaptId;
            const chaptMetaData = isChapterSuplementListInstance.getItem(chaptCommonIdbKey);
            if (!chaptMetaData) { return false; }
            if (chaptMetaData.subChapters) {
                chaptMetaData.subChapters.map(subChpatElem => {
                    ccContIdbKey = subChpatElem.chapterId;
                    isCcHighlightInstance && isCcHighlightInstance.removeItem(`chapterId|${ccContIdbKey}`);
                    removeChapterContentAndImages(isCcContentInstance, ccContIdbKey);
                });
                if (chaptMetaData.pageHtmlLocation) {
                    isCcHighlightInstance && isCcHighlightInstance.removeItem(chaptCommonIdbKey);
                    removeChapterContentAndImages(isCcContentInstance, ccContIdbKey);
                }
            } else {
                isCcHighlightInstance && isCcHighlightInstance.removeItem(chaptCommonIdbKey);
                removeChapterContentAndImages(isCcContentInstance, ccContIdbKey);
            }
            isChapterSuplementListInstance.removeItem(chaptCommonIdbKey);
        });
        return true;
    } catch (error) {
        return false;
    }
}
export const removeChapterContentAndImages = async (ccContDb, ccContDbKey) => {
    await ccContDb.keys().then(ccContKeys => {
        ccContKeys.forEach(contKey => {
            if (contKey.indexOf(ccContDbKey) !== -1) { ccContDb.removeItem(contKey); }
        });
    });
}
const addLastRead = (isbn, userId, time) => {
    const lastReadQueueInstance = localforage.createInstance({
        name: 'Offline-sync',
        driver: localforage.INDEXEDDB,
        storeName: 'lastread'
    });
    lastReadQueueInstance.setItem(`${userId}|${isbn}`, time);
}
export const offlineRead = { add: addLastRead }